/**
 * Application routes constants
 * Centralized route definitions for consistent navigation
 */

export const ROUTES = {
  // Main routes
  HOME: '/',
  MODEL: '/model',
  PROFILE: '/profile',
  LOOK_LIKE: '/look-like',
  CREATE: '/create',
  SUBSCRIPTIONS: '/subscriptions',
  IMAGE_STUDIO: '/image-studio',
  VIDEO_STUDIO: '/video-studio',
  PROMPT_LIBRARY: '/prompt-library',
  IMAGE_EDITOR: '/image-editor',
  STAGE_DESIGNER: '/stage-designer',
  SPEECH_GENERATION: '/speech-generation',
  UGC_TALK_GENERATION: '/ugc-talk-generation',

  // Auth routes
  AUTH: {
    BASE: '/auth',
    REGISTER: '/auth/sign-in',
  },

  // Dynamic routes
  KONTEXT: (kontextType: string) => `/kontext/${kontextType}`,

  // Utility routes
  NOT_FOUND: '*',
} as const;

// Type for route values
export type RouteValue = (typeof ROUTES)[keyof typeof ROUTES] | string;
